// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ListItemNew/style.css
// module id = 1871
// module chunks = 0